import axios from 'axios';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelTokenList;
let cancelTokenListPagination;
let cancelTokenConfig;
export const getConfig = () => {
  if (typeof cancelTokenConfig !== typeof undefined) {
    cancelTokenConfig.cancel('Operation canceled due to new request.');
  }

  cancelTokenConfig = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/configuration', { params: pickDevParams, cancelToken: cancelTokenConfig.token });
};

export const getMainList = (payload) => {
  if (typeof cancelTokenList !== typeof undefined) {
    cancelTokenList.cancel('Operation canceled due to new request.');
  }

  // Если заново запрашиваем листинг, пагинация в Pending не актуальная
  if (cancelTokenListPagination) {
    cancelTokenListPagination.cancel('Operation canceled');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenList = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenList.token,
  });
};

export const getMainListPagination = (payload) => {
  if (typeof cancelTokenListPagination !== typeof undefined) {
    cancelTokenListPagination.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenListPagination = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/list-pagination', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenListPagination.token,
  });
};

export const getReferralsList = (payload) => {
  if (typeof cancelTokenList !== typeof undefined) {
    cancelTokenList.cancel('Operation canceled due to new request.');
  }

  // Если заново запрашиваем листинг, пагинация в Pending не актуальная
  if (cancelTokenListPagination) {
    cancelTokenListPagination.cancel('Operation canceled');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenList = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/referrals/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenList.token,
  });
};

export const getReferralsListPagination = (payload) => {
  if (typeof cancelTokenListPagination !== typeof undefined) {
    cancelTokenListPagination.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenListPagination = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/referrals/list-pagination', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenListPagination.token,
  });
};

export const getPayoutsList = (payload) => {
  if (typeof cancelTokenList !== typeof undefined) {
    cancelTokenList.cancel('Operation canceled due to new request.');
  }

  // Если заново запрашиваем листинг, пагинация в Pending не актуальная
  if (cancelTokenListPagination) {
    cancelTokenListPagination.cancel('Operation canceled');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenList = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/payouts/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenList.token,
  });
};

export const getPayoutsListPagination = (payload) => {
  if (typeof cancelTokenListPagination !== typeof undefined) {
    cancelTokenListPagination.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenListPagination = axios.CancelToken.source();
  return axiosInstance.get('/affiliates/payouts/list-pagination', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenListPagination.token,
  });
};

export const changeStatus = (id, status) => axiosInstance.post(`/affiliates/change-status/${id}`, { status, ...pickDevParams });

export const approvePayout = (id) => axiosInstance.post(`/affiliates/payout/approve/${id}`, pickDevParams);

export const rejectPayout = (id) => axiosInstance.post(`/affiliates/payout/reject/${id}`, pickDevParams);
